$(document).on("change", ".filter-stat", function () {
    filterContract('.filter-stat', '.filter-subject');
});

$(document).on("change", ".filter-subject", function () {
    filterContract('.filter-subject', '.filter-registration');
});

$(document).on("change", ".filter-registration", function () {
    filterContract('.filter-registration', '.filter-contract');
});


function filterContract(source, target, reroll = true) {
    source = $(document).find(source);
    target = $(document).find(target);

    let sourceVal = source.val().split("_")[0];

    target.find('option').each(function (index) {
        if ($(this).val() == "") {
            return;
        }
        $(this).show();

        let valArr = $(this).val().split("_")[1];

        if (sourceVal != "" && parseInt(valArr) != parseInt(sourceVal)) {
            $(this).hide();
            return;
        }
    });

    if (reroll) {
        target.val("");
    }
//    $(document).find(".help-block").hide();
}